import { render, staticRenderFns } from "./InvoiceViewItem.vue?vue&type=template&id=6b60d2e6&scoped=true&"
import script from "./InvoiceViewItem.vue?vue&type=script&lang=js&"
export * from "./InvoiceViewItem.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceViewItem.vue?vue&type=style&index=0&id=6b60d2e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b60d2e6",
  null
  
)

export default component.exports